import React, { useEffect, useState } from "react";

const TruckAndCrewSection = ({ 
  handleUpdateBookingObject ,
  completeBookingObj,
  handleEstimatePrice
}) => {
  const [vbo, setVbo] = useState({});

  useEffect(() => {
    try {
      const raw = localStorage.getItem("VBO");
      if (!raw) return;
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object") setVbo(parsed);
    } catch (error) {
      // if VBO is missing or malformed, don't crash — keep defaults
      console.log("Error reading VBO from localStorage:", error);
    }
  }, []);

  const labourNeeded =
    typeof vbo.labourNeeded === "number"
      ? vbo.labourNeeded
      : typeof vbo.labourNeeded === "string" && vbo.labourNeeded.trim() !== ""
      ? parseInt(vbo.labourNeeded, 10) || 2
      : 2;

  const selectedVehicleName = completeBookingObj?.vehicle?.title || "";

  return (
    <div className="mb-4">
      <div className="text-[#211F59] text-[14px] font-semibold mb-2"></div>
      <div className="flex gap-x-2 items-center mb-[7px]">
        <img
          src="/images/NewUiIcons/truckandcrewicon.svg"
          alt="Truck and crew icon"
        />
        <p className="text-[#7876A1] text-[16px] font-bold">Truck & crew</p>
          <img
              src="/images/NewUiIcons/Edit.svg"
              alt="edit"
              className="w-[23px] h-[23px] cursor-pointer"
              onClick={()=>{
                handleUpdateBookingObject("tripStatus", "vehicle", "EditVehicleFromSummary")
                handleEstimatePrice();
              }}
            />
      </div>
      <ul className="text-[#211F59] text-[14px] font-semibold list-[square] pl-12">
        {/* selected vehicle name */}
        {selectedVehicleName && <li>{`1x ${selectedVehicleName}`}</li>}

        {/* number of movers */}
        <li>{`${labourNeeded}x Movers`}</li>
      </ul>
        <div
        style={{
          borderTop: "1px solid #7876A1",
          height: 0,
          marginTop: "18px",
          marginBottom: "23px",
        }}
        
      />
    </div>
  );
};

export default TruckAndCrewSection;
